import { Component, type ReactNode } from "react";
export default class PageLoadBoundary extends Component<{children: ReactNode}, {failed: boolean}> {
  state = {failed:false};
  static getDerivedStateFromError() { return {failed:true}; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="page"><h1>This page could not load</h1><p>Check your connection, then reload the page to try again.</p><button onClick={()=>window.location.reload()} style={{minHeight:44,padding:"10px 16px"}}>Reload page</button><p><a href="/">Return home</a></p></div>;
  }
}
